import { sortElementInt, trimLowerCase } from './shared';
import { store } from '../redux/store/store';
import { slimTier, advancedTier } from '../constants/form';
import { envSetting } from '../constants/envSetting';
import { isLendecyApp } from './base';

/**** Export functions  ****/
/**
 * Return tiers active, regular and hide in false for menu
 * @returns
 */
export const userTier = () => {
  const { level:userLevel, appOrigin } = store.getState().user;
  const { requestLanguage } = store.getState().base;
  const { 
    data: { 
      product_request: { 
        user: userInfo 
      } = {}
    } = {}
  } = store.getState().personData || {}
  const staticData = store.getState().staticData[`data_${trimLowerCase(requestLanguage)}`];

  if (!staticData) {
    console.error(`No static data found for language: ${requestLanguage}`);
    return [];
  }

  const {
    tier:tiers,
    application:applications
  } = staticData

  const [tierApp] = applications?.filter(application =>
    trimLowerCase(application?.unique_name) === trimLowerCase(appOrigin) ||
    trimLowerCase(application?.unique_name) === trimLowerCase(appOrigin?.appOriginData)
    );
  let result = [];

  result = tiers?.filter(
    tier => tier?.active && tier?.regular && !tier?.hide);
  result = sortElementInt(result, 'verification_level');

  let modifyableResult = result.map(tier => ({ ...tier }));
  modifyableResult?.forEach((tier, index) => {
    modifyableResult[index].show = false;
    modifyableResult[index].disabled = true;
    modifyableResult[index].edit = false;
    if (parseInt(tier?.verification_level) <= parseInt(tierApp?.tier)) {
      modifyableResult[index].show = true;
      modifyableResult[index].disabled = false;
      modifyableResult[index].edit = false;
      if (parseInt(tier.verification_level) < parseInt(userLevel + 1)) {
        modifyableResult[index].edit = true;
      }
      if (parseInt(tier.verification_level) > parseInt(userLevel + 1)) {
        modifyableResult[index].disabled = true;
      }
      /* Conditionally hide tier according to state */
      const conditionalStates = envSetting?.conditionalStates.split(',')

      const isLendecy = isLendecyApp()
      if (Number(modifyableResult[index]['verification_level']) === 4 && isLendecy){
        if (conditionalStates.includes(trimLowerCase(userInfo?.state))) {
          modifyableResult[index].show = false;
        }
      }
      /* Conditionally hide tier according to AppOrigin */
      if (isLendecy && (modifyableResult[index]?.['unique_name'] === advancedTier)){
          modifyableResult[index].show = false;
      } else if ((modifyableResult[index]['unique_name'] === slimTier) && !isLendecy) {
          modifyableResult[index].show = false;
      }
    }
  });

  return modifyableResult;
};

/**
 * Return tiers active, regular and hide in false for menu
 * @returns
 */
export const slimAdvancedTier = () => {
  const { requestLanguage } = store.getState().base;
  const { data: 
    { product_request: 
      { user: userInfo } = {}
    } = {}
  } = store?.getState()?.personData || {}
  const staticData = store.getState().staticData[`data_${trimLowerCase(requestLanguage)}`];

  if (!staticData) {
    console.error(`No static data found for language: ${requestLanguage}`);
    return [];
  }

  const {
    tier:tiers,
  } = staticData

  const result = tiers?.filter(tier => tier.unique_name === slimTier)
  return result;
};

/**
 * Assign value for default in checkbox
 * @param {Object} tiers
 * @returns
 */
export const defaultChecked = tiers => {
  const { level:userLevel } = store.getState().user;

  tiers?.forEach((tier, index) => {
    tiers[index].checked = (
      parseInt(userLevel) >= parseInt(tier.verification_level));
  });

  return tiers;
};